import { useState, useEffect } from "react";
import styles from './expenses.module.css';
import { Link } from "react-router-dom";
import {API_URL} from '../../trip/utils/fatch';

export const ExpenseManagement = () => {


    const [expenses, setExpenses] = useState([]);

  
 /*    const fakeUser = [

        {
            created_at: "2025-08-18T19:25:28.000Z",
            current_trip_id: 20,
            email: "2048yossi@gmail.com",
            email_verified: false,
            firstname: "joseph",
            id: 31,
            is_active: true,
            last_login: null,
            lastname: "goldberger",
            role: "user",
            token_expires_at: null,
            updated_at: "2025-08-18T19:25:28.000Z",
            verification_token: null
        }

    ] */



    async function fetchAndRenderAllData() {


        try {


            const response = await fetch(`${API_URL}/admin/allExpenses`,
                {
                    method: 'GET', // Use 'POST' for login
                    credentials: 'include', // ✅ Required for cookies

                }
            );
            // console.log(budgetResponse.status);
            if (!response.ok) {
                console.log(response.status);

return

            }
            const data = await response.json();
            console.log(data);
            
            setExpenses(data.expenses);




        } catch (error) {
            console.error("Error fetching data:", error);


        }
    }

    useEffect(()=>{
        fetchAndRenderAllData();
    },[])
    return (<>
       

<main className={styles.main}>
    <div className={styles.pageHeader}>
         <Link to="/admin" className={styles.adminLink}>Go Back</Link>

      <h2 className={styles.h2}>Expenses Management</h2>
      <div className={styles.adminLink} style={{visibility: 'hidden'}}></div>

    </div>
   
       
        
        <table className={styles.userTable}>
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Description</th>
                    <th>Amount</th>
                    <th>Category</th>
                    <th>Date</th>
                    <th>Trip Id</th>
                    <th>User Id</th>

                    

                    
                </tr>
            </thead>
            <tbody>
                {expenses.map((expense) => (
                    <tr key={expense.id}>
                         <td>{expense.id}</td>
                        <td>{expense.description}</td>
                        <td>{expense.amount}</td>
                        <td>{expense.category}</td>
                        <td>{expense.timestamp}</td> 
                        <td>{expense.trip_id}</td>
                        <td>{expense.user_id}</td>
                    </tr>
                ))}
            </tbody>
        </table>


</main>

    </>)
                       
}